import { Fragment } from "react";
import { cx } from "./util";

/** Numbered steps in bordered boxes joined by ASCII arrows (──▶ across, │▼ on phones). */
export default function Pipeline({ steps = [], direction = "horizontal", className, style }) {
  const vertical = direction === "vertical";
  const cols = steps.map(() => "minmax(0,1fr)").join(" auto ");
  return (
    <div className={cx("gd-pipe", vertical && "gd-pipe-v", className)} style={vertical ? style : { gridTemplateColumns: cols, ...style }}>
      {steps.map((s, i) => (
        <Fragment key={i}>
          {i > 0 && <div className="gd-arrow" aria-hidden="true">{vertical ? "│\n▼" : "──▶"}</div>}
          <div className="gd-step">
            <h4>{s.name}</h4>
            <p>{s.detail}</p>
            {s.out && <div className="gd-step-out">out: <b>{s.out}</b></div>}
          </div>
        </Fragment>
      ))}
    </div>
  );
}
